// Client-portal billing API wrappers. Mirrors api/billingThreshold.js
// but talks to the client-scoped endpoints (no staff-only actions).
import api from '@src/api/clients';

const BILLING_BASE = 'dashboard/my-billing-profiles/';
const LEDGER_BASE = 'dashboard/my-threshold-charges/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== '',
    ),
  );

export const listMyBillingProfiles = () =>
  api.request({ url: BILLING_BASE, method: 'GET' });

export const retrieveMyBillingProfile = (profileId) =>
  api.request({ url: `${BILLING_BASE}${profileId}/`, method: 'GET' });

export const fetchMyBillingLiveStatus = (profileId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/live-status/`,
    method: 'GET',
  });

export const fetchMyPaymentMethods = (profileId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/payment-methods/`,
    method: 'GET',
  });

export const createMySetupIntent = (profileId, paymentMethodType = 'card') =>
  api.request({
    url: `${BILLING_BASE}${profileId}/create-setup-intent/`,
    method: 'POST',
    payload: { payment_method_type: paymentMethodType },
  });

export const setMyDefaultPaymentMethod = (profileId, paymentMethodId) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/set-default-payment-method/`,
    method: 'POST',
    payload: { payment_method_id: paymentMethodId },
  });

export const updateMyThreshold = (profileId, thresholdAmount) =>
  api.request({
    url: `${BILLING_BASE}${profileId}/update-threshold/`,
    method: 'POST',
    payload: { threshold_amount: thresholdAmount },
  });

export const listMyThresholdCharges = (params = {}) =>
  api.request({
    url: LEDGER_BASE,
    method: 'GET',
    payload: cleanParams(params),
  });
